import { use_slice_ui, use_slice_workspace } from '@/hooks/store/use_slices';
import { PageSettingsWorkspaceViewsDesktop } from './PageSettingsWorkspaceViewsDesktop';
import { PageSettingsWorkspaceViewsMobile } from './PageSettingsWorkspaceViewsMobile';
import { WatcherSlugPageSettingsWorkspace } from './watchers/WatcherSlugPageSettingsWorkspace';
import { WatcherWorkspaceSettingsRedirectFromSharedToPersonalTab } from './watchers/WatcherWorkspaceSettingsRedirectFromSharedToPersonalTab';

export function PageSettingsWorkspace() {
  const { global_is_mobile } = use_slice_ui(['global_is_mobile']);

  const { workspace_current } = use_slice_workspace(['workspace_current']);

  return (
    <>
      <WatcherSlugPageSettingsWorkspace />
      <WatcherWorkspaceSettingsRedirectFromSharedToPersonalTab />

      {!workspace_current.is_stub() && (global_is_mobile ? <PageSettingsWorkspaceViewsMobile /> : <PageSettingsWorkspaceViewsDesktop />)}
    </>
  );
}
